import axios from "axios";
axios.interceptors.response.use(
  function (response) {
    // ステータスコードが 2xx の範囲にある場合、この関数が起動します
    // リクエスト データの処理
    return response;
  },
  function (error) {
    // ステータスコードが 2xx の範囲外の場合、この関数が起動します
    // リクエスト エラーの処理
    const res = error.response;
    if (res.status === 401) {
      window.location.href = "/users/sign_in";
    }
    return Promise.reject(error);
  }
);

interface Chunk {
  file: string;
  src?: string;
  isEntry?: boolean;
  dynamicImports?: string[];
  css?: string[];
  assets?: string[];
}

interface Manifest {
  [key: string]: string | Chunk;
}

interface ElementOption {
  type?: string
  defer?: boolean
  async?: boolean
}

const getManifest = async (url: string): Promise<Manifest> => {
  return axios.get(url).then((response) => {
    return response.data
  })
}

const createJsElement = (url: string, { type, defer, async }: ElementOption = {}): HTMLElement => {
  const el = document.createElement("script");
  el.src = url;
  if (type) el.type = type;
  if (defer) el.defer = true;
  if (async) el.async = true;

  return el;
}

const createCssElement = (url: string): HTMLElement => {
  const el = document.createElement("link");
  el.rel = "stylesheet";
  el.href = url;
  return el;
}

const getElement = (path: string, options?: ElementOption): HTMLElement | undefined => {
  const ext = path.split(".").reverse()[0];
  switch (ext) {
    case "js":
      return createJsElement(path, options);
    case "css":
      return createCssElement(path);
  }
  return undefined;
}

const appendAssetTag = (path: string, targetTag: HTMLElement, options?: ElementOption): void => {
  const el = getElement(path, options);
  if (el) targetTag.appendChild(el);
}

export const getAssetsByKeys = (path: string, keys: string[], assetOrigin?: string) => {
  const manifestUrl = new URL(path, assetOrigin || window.location.origin)
  getManifest(manifestUrl.href).then((manifest) => {
    const existedKeys = keys.filter((key) => {
      return manifest[key];
    });
    const headEl = document.getElementsByTagName("head")[0];
    for (const key of existedKeys) {
      const value = manifest[key];
      if (typeof value === 'string') {
        const assetUrl = new URL(value, manifestUrl);
        appendAssetTag(assetUrl.href, headEl);
      } else {
        const fileUrl = new URL(value.file, manifestUrl.origin);
        appendAssetTag(fileUrl.href, headEl, { type: "module" });
        const cssFiles = value.css || []
        cssFiles.forEach((cssFile) => {
          const cssUrl = new URL(cssFile, manifestUrl.origin);
          appendAssetTag(cssUrl.href, headEl);
        });
      }
    }
  })
}

export const getPlayerAssetsByKeys = (path: string, keys: string[]) => {
  return getAssetsByKeys(path, keys, process.env.PLAYER_V2_ASSET_ORIGIN);
}
